module.exports = __webpack_public_path__ + "static/media/pocket_icon.2706c4a9.svg";